const translations = {
	en: {
		register: "Register",
		wait: "Waiting",
		countdown: "Waiting...",
		login_button_text: "Complete your payment",
		order_received: "Thank you! Your order has been received - we will call you to confirm it.",
		emailSuggestion: "Did you mean {email}?",
		emailCheck: "Please check your email address - it does not look right.",
		formsPlaceholders: {
			firstName: "First name",
			lastName: "Last name",
			fullName: "Full name",
			email: "Your email address",
			address: "Your address",
			country: "Country",
			city: "City",
			zip_code: "Zip / Postal code",
		},
	},
	el: {
		register: "Κανω ΕΓΓΡΑΦΗ",
		wait: "Περιμένετε",
		countdown: "Δεν είναι δυνατή η εγγραφή σας αυτήν τη στιγμή.",
		login_button_text: "Πρόσβαση στον λογαριασμό σας",
		order_received:
			"Ευχαριστούμε! Η παραγγελία σου καταχωρήθηκε - θα σε καλέσουμε για να την επιβεβαιώσουμε.",
		emailSuggestion: "Μήπως εννοείς {email};",
		emailCheck: "Έλεγξε το email σου - δεν φαίνεται σωστό.",
		formsPlaceholders: {
			firstName: "Ονομα",
			lastName: "Επίθετο",
			fullName: "Πλήρες όνομα",
			email: "η ηλεκτρονική σου διεύθυνση",
			address: "Διεύθυνση",
			country: "Χώρα",
			city: "Πόλη",
			zip_code: "Ταχυδρομικός κώδικας",
		},
	},
	hi: {
		register: "ऑर्डर करें",
		wait: "कृपया प्रतीक्षा करें",
		countdown: "कृपया प्रतीक्षा करें...",
		login_button_text: "अपना भुगतान पूरा करें",
		order_received: "धन्यवाद! आपका ऑर्डर मिल गया है - हम इसकी पुष्टि के लिए आपको कॉल करेंगे।",
		emailSuggestion: "क्या आपका मतलब {email} था?",
		emailCheck: "कृपया अपना ईमेल पता जांचें - यह सही नहीं लग रहा है।",
		formsPlaceholders: {
			firstName: "पहला नाम",
			lastName: "उपनाम",
			fullName: "पूरा नाम",
			email: "ईमेल पता",
			address: "पता",
			country: "देश",
			city: "शहर",
			zip_code: "पिन कोड",
		},
	},
};

const active =
	translations[document.documentElement.lang] || translations.en;

export function t(key) {
	return active[key];
}
